export default "__VITE_ASSET__C$jASmj6__"